export const positionTypes = {
  GET_POSITION: "GET_POSITION",
  GET_POSITION_BY_ID: "GET_POSITION_BY_ID",
  SET_POSITION: "SET_POSITION",
  SET_POSITION_BY_ID: "SET_POSITION_BY_ID",
  GET_POSITION_USER: "GET_POSITION_USER",
  SET_POSITION_USER: "SET_POSITION_USER",
};

export const getPosition = () => ({
  type: positionTypes.GET_POSITION,
});

export const setPosition = (payload: any) => ({
  type: positionTypes.SET_POSITION,
  payload,
});

export const getPositionById = (id: any) => ({
  type: positionTypes.GET_POSITION_BY_ID,
  payload: id,
});

export const setPositionById = (payload: any) => ({
  type: positionTypes.SET_POSITION_BY_ID,
  payload,
});

export const getPositionUser = () => ({
  type: positionTypes.GET_POSITION_USER,
});

export const setPositionUser = (payload: any) => ({
  type: positionTypes.SET_POSITION_USER,
  payload,
});
